import {
  ListagemConteudoEletronicoComponent
} from './../listagem-conteudo-eletronico/listagem-conteudo-eletronico.component';
import {element} from 'protractor';
import {ConteudoEletronicoService} from './../../../service/caixa/conteudo-eletronico.service';
import {ConteudoEletronicoModel} from './../../../model/caixa/conteudoeletronico.model';
import {DocumentListComponent} from '@alfresco/adf-content-services';
import {DialogConfirmComponent} from './../../dialog/dialog-confirm/dialog-confirm.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import {ConteudoService} from './../../../service/caixa/conteudo.service';
import {ConteudoModel} from './../../../model/caixa/conteudo.model';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {TipoConteudoModel} from './../../../model/caixa/tipoconteudo.model';
import {TipoConteudoService} from './../../../service/caixa/tipo-conteudo.service';
import {CaixaModel} from './../../../model/caixa/caixa.model';
import {CaixaService} from './../../../service/caixa/caixa.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '@alfresco/adf-core';
import {Component, OnInit, ViewChild} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {ConfigurarPastaServiceService} from 'app/configurar-pasta-service.service';

@Component({
  selector: 'app-adicionar-conteudo',
  templateUrl: './adicionar-conteudo.component.html',
  styleUrls: ['./adicionar-conteudo.component.scss']
})
export class AdicionarConteudoComponent implements OnInit {
  public loading = false;
  public caixaId;
  public deData;
  public caixa = {} as CaixaModel;
  public tipoConteudos: TipoConteudoModel[];
  public conteudo = {} as ConteudoModel;
  public conteudoLista = {} as ConteudoModel;
  conteudoForm: FormGroup;
  submit = false;
  adicionarConteudo = false;
  listarConteudo = true;
  adicionarConteudoEletronico = false;
  listarConteudoEletronico = false;
  displayedColumns = ['rgItem', 'tipoConteudo', 'descricaoConteudo', 'dataInicial', 'dataFinal', 'numDocIni', 'numDocFin', 'origem', 'acoes'];
  displayedColumnsEletronico = ['nome', 'excluir'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginatorEletronico: MatPaginator;
  @ViewChild(MatSort) sortEletronico: MatSort;
  conteudosAny: any[] = [];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceEletronico = new MatTableDataSource<ConteudoEletronicoModel>([]);
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @ViewChild(DocumentListComponent)
  public statusDaCaixa;
  documentList: DocumentListComponent;
  showViewer: Boolean = false;
  nodeId: String = null;
  filesSelected: any[] = [];
  buttonIncluir = false;
  eletronicos: any[] = [];
  currentFolderId = '-my-';
  nomeColuna = 'name';
  root = 'Meus arquivos';
  rootId = '-my-';
  apenasLeitura = false;
  tiposDocumentais: any[];
  caixaAberta;
  caixaFechada;

  constructor(private authService: AuthenticationService,
              private fb: FormBuilder,
              private service: ConfigurarPastaServiceService,
              private router: Router,
              private route: ActivatedRoute,
              private caixaService: CaixaService,
              private _snackBar: MatSnackBar,
              private tipoConteudoService: TipoConteudoService,
              private conteudoService: ConteudoService,
              private dialog: MatDialog,
              private conteudoEletronicoService: ConteudoEletronicoService) {
    this.route.params.subscribe(params => this.caixaId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.caixaId), 'pcdoc');
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.loading = true;
    this.conteudoForm = this.fb.group({
      rgItem: [''],
      descricaoConteudo: ['', Validators.required],
      origem: [''],
      dataInicial: [''],
      dataFinal: [''],
      numeroDocumentos: [''],
      tipoConteudo: [null],
      nodeDicionario: [null, Validators.required],
      caixa: [null],
      numDocInicial: [''],
      numDocFinal: ['']
    });
    this.getCaixa(this.caixaId);
    //this.getTipoConteudo();
    this.getConteudos(this.caixaId);


  }

  fecharCaixa() {
    this.loading = true;
    this.caixaService.fecharCaixa(this.caixaId).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess('Caixa fechada com sucesso !');
      this.getCaixa(this.caixaId);
      this.router.navigate(['/caixas']);
    }, error => {
      this.loading = false;
      console.error(error);
    });
  }

  fecharCaixaDialog() {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: {
          name: 'Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.',
          from: 'adicionar-conteudo.component.ts'
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: any) => {
        if (confirmed.apagar === true) {
          this.fecharCaixa();
          this.imprimirRelatorio(this.caixa.id);
        }
      });
  }

  imprimirRelatorio(caixaId: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: 'Deseja imprimir o relatório desta caixa ?',
        from: 'adicionar-conteudo.component.ts'
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.relatorioCaixa(caixaId);
      }
    });
  }
  
  relatorioCaixa(caixaId) {
    const caixaIdRecebido = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    window.open(
      `relatorio-caixa/${caixaIdRecebido}`,
      "_blank",
      "location=yes,scrollbars=yes,status=yes"
    ); // Open new window
  }

  abrirCaixaDialog() {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: {
          name: 'Deseja abrir esta caixa ?',
          from: 'adicionar-conteudo.component.ts'
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: any) => {
        if (confirmed.apagar === true) {
          this.abrirCaixa();
        }
      });
  }

  abrirCaixa() {
    this.loading = true;
    this.caixaService.abrirCaixa(this.caixaId).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess('Caixa aberta com sucesso !');
      this.getCaixa(this.caixaId);
    }, error => {
      this.loading = false;
      console.error(error);
    });
  }

  onNodeDblClicked(e) {
    this.currentFolderId = e.detail.node.entry.guid;
    if (e.detail.node.entry.guid !== null) {
      this.nomeColuna = 'name';
      this.currentFolderId = e.detail.node.entry.guid;
    } else {
      this.nomeColuna = 'title';
      this.currentFolderId = e.detail.node.entry.guid;
    }
  }

  getNodeClienteArea(clienteId, areaId) {
    this.service.getNodeClienteArea(clienteId, areaId).subscribe(data => {
      // console.log(data);
      if (data.length === 0) {
        this.openSnackBarError('Nenhum Tipo Documental associado !');
        this.tiposDocumentais = null;
        this.loading = false;
      } else {

        // this.dataSource = new MatTableDataSource(data);
        // this.dataSource.paginator = this.paginator;
        // this.paginator._pageIndex = 0;
        // this.dataSource.sort = this.sort;
        this.tiposDocumentais = data;
        // console.log(this.tiposDocumentais);
        this.tipoConteudos = this.tiposDocumentais;
        this.loading = false;
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  exibirConteudoEletronico(element) {
    const dialogRef = this.dialog.open(ListagemConteudoEletronicoComponent, {
      width: '100%',
      data: {conteudoId: element.id, descricaoConteudo: element.descricaoConteudo}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      // console.log(result);
    });
  }

  goMeusSites() {
    this.nomeColuna = 'title';
    this.root = 'Meus Sites';
    this.rootId = '-mysites-';
    this.currentFolderId = '-mysites-';
  }

  goMeusArquivos() {
    this.nomeColuna = 'name';
    this.root = 'Arquivos Pessoais';
    this.rootId = '-my-';
    this.currentFolderId = '-my-';
  }

  eventTeste(e) {
    if (e.name === 'Sites') {
      e.id = '-mysites-';
      this.nomeColuna = 'title';
    } else if (e.name === 'User Homes') {
      e.id = '-my-';
    } else if (e.name === 'Meus Sites') {
      this.nomeColuna = 'title';
    }
  }

  deleteConteudo(conteudoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este conteúdo ?', from: 'adicionar-conteudo.component.ts'}
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarItem(this.caixaId, conteudoId);
      }
    });
  }

  deleteConteudoEletronico(conteudoEleId: number) {
    const dialogRefEle = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja desvincular o arquivo selecionado ?', from: 'adicionar-conteudo.component.ts'}
    });

    dialogRefEle.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarContrueoELetronico(conteudoEleId);
      }
    });
  }

  apagarContrueoELetronico(conteudoEleId: number) {
    this.loading = true;
    this.conteudoEletronicoService.deleteConteudoEle(conteudoEleId).subscribe(() => {
      this.loading = false;
      this.openSnackBarSuccess('Arquivo desviculado com sucesso !');
      this.listarConteudos(this.conteudoLista.id);
    }, err => {
      this.loading = false;
      this.openSnackBarError('Erro ao tentar desvincular arquivo !');
      console.error(err);
    });
  }

  showPreview(event) {
    this.showViewer = false;
    if (event.value.entry.isFile) {
      this.nodeId = event.value.entry.id;
      this.showViewer = true;
    }
  }

  selectedDocumentList(event: any) {
    event.forEach(element => {
      if (element.entry.isFile) {
        const found = this.filesSelected.find(el => el.nodeId === element.entry.id);
        if (found != undefined) {
          return this.openSnackBarError('Não pode adicionar arquivos duplicados !');
        } else {
          this.filesSelected.push({
            nome: element.entry.name,
            nodeId: element.entry.id
          });
          this.buttonIncluir = true;
        }
      } else {
        this.openSnackBarError('Não é permitido incluir pasta !');
      }
    });
  }

  incluirEletronico(conteudoId: number) {
    this.loading = true;
    this.conteudoEletronicoService.adicionarConteudoEletronico(this.filesSelected, conteudoId).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess('Documentos eletrônicos adicionados com sucesso !');
      this.adicionarConteudoEletronico = false;
      this.listarConteudoEletronico = true;
      this.listarConteudos(conteudoId);
      this.filesSelected = [];
      this.buttonIncluir = false;
    }, err => {
      this.loading = false;
      if (err.error.message === 'Conteúdo eletrônico já adicionado !') {
        this.openSnackBarError(err.error.message);
      } else {
        this.openSnackBarError('Erro ao adicionar os documentos !');
      }
      console.error(err);
    });
  }

  cancelarInclusao() {
    this.listarConteudoEletronico = false;
    this.listarConteudo = true;
  }

  incluirConteudoEletronico() {
    this.listarConteudoEletronico = false;
    this.adicionarConteudoEletronico = true;
  }

  listarConteudos(conteudoId: number) {
    this.conteudoEletronicoService.listarConteudosEle(conteudoId).subscribe(data => {
      this.eletronicos = data;
      this.dataSourceEletronico = new MatTableDataSource(this.eletronicos);
      this.dataSourceEletronico.paginator = this.paginatorEletronico;
      this.dataSourceEletronico.sort = this.sortEletronico;
    }, err => {
      console.error(err);
    });
  }

  excluirDoc(file) {
    const foundIndex = this.filesSelected.findIndex(x => x.nodeId === file.nodeId);
    this.filesSelected.splice(foundIndex, 1);
    if (this.filesSelected.length === 0) {
      this.buttonIncluir = false;
    }
  }

  addConteudo() {
    this.conteudo = new ConteudoModel();
    this.listarConteudo = false;
    this.adicionarConteudo = true;
    this.setTypeOnInit();
    // this.isRgAutomatico();
  }

  reset() {
    this.submit = false;
    this.conteudoForm.reset();
    this.conteudo.id = undefined;
  }

  goListagem() {
    this.adicionarConteudo = false;
    this.listarConteudo = true;
    this.conteudoForm.reset();
    this.submit = false;
    this.conteudo.id = undefined;
  }

  goListagem2() {
    this.adicionarConteudoEletronico = false;
    this.listarConteudo = true;
    this.conteudoForm.reset();
    this.submit = false;
    this.conteudo.id = undefined;
  }

  getConteudos(caixaId: number) {
    this.conteudoService.listaItens(caixaId).subscribe(data => {
      // console.log(data);
      this.conteudosAny = data;
      this.dataSource = new MatTableDataSource(this.conteudosAny);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = false;

    }, err => {
      console.error(err);
    });

  }

  getCaixa(idCaixa: Number) {
    this.caixaService.getCaixaUnica(idCaixa).subscribe(data => {
      this.caixa = data;
      // console.log(this.caixa);
      if (data.statusCaixa === 'EM_PROCESSO_DE_CADASTRO') {
        this.statusDaCaixa = true;
        this.caixaAberta = true;
        this.caixaFechada = false;

      } else {
        this.statusDaCaixa = false;
        this.caixaFechada = true;
        this.caixaAberta = false;
      }
      // console.log(this.statusDaCaixa);
      this.getNodeClienteArea(this.caixa.cliente.id, this.caixa.area.id);
      this.conteudoForm.get('caixa').setValue(this.caixa);
    }, err => {
      console.error(err);
    });
  }

  isRgAutomatico() {
    if (this.caixa.cliente.gerarRG) {
      this.caixaService.gerarRGConteudo(this.caixa.id).subscribe(data => {
        const resultData = data;
        if (resultData.cod == 200) {
          this.conteudoForm.get('rgItem').setValue(resultData.result);
        } else {
          this.conteudoForm.get('rgItem').setValue('');
        }
      });
    }
  }

  getTipoConteudo() {
    this.tipoConteudoService.getTiposRegistros().subscribe(data => {
      this.tipoConteudos = data;
    }, err => {
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
  }

  adicionarItem() {
    this.loading = true;
    const conteudo = this.conteudoForm.value;
    this.conteudoService.incluirItens(this.caixaId, conteudo).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess(`Conteúdo adicionado com sucesso !`);
      this.getConteudos(this.caixaId);
      this.conteudoForm.reset();
      this.submit = false;
      this.adicionarConteudo = false;
      this.listarConteudo = true;
      this.getCaixa(this.caixaId);
    }, err => {
      this.loading = false;
      console.error(err);
      if (err.error.message === 'Conteúdo já criado com este RG de Item !') {
        this.openSnackBarError(err.error.message);
      } else {
        this.openSnackBarError('Preencha todos os campos obrigatórios !');
      }
    });
  }

  apagarItem(caixaId: number, conteudoId: number) {
    this.loading = true;
    this.conteudoService.apagarItem(caixaId, conteudoId).subscribe(() => {
      this.loading = false;
      this.openSnackBarSuccess('Conteúdo excluído com sucesso !');
      this.getConteudos(this.caixaId);
      this.getCaixa(this.caixaId);
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Erro ao tentar excluir este conteúdo');
    });
  }


  getDados(dados) {
    // console.log(dados);
    this.conteudo = {...dados};
    this.listarConteudo = false;
    this.adicionarConteudo = true;
  }

  compararNodeEditConteudo(obj1, obj2) {
    return obj1 && obj2
      ? obj1.title === obj2.title && obj1.id === obj2.id
      : obj1 === obj2;
  }

  addConteudoEletronico(dados) {
    this.conteudoLista = {...dados};
    this.listarConteudo = false;
    this.listarConteudos(dados.id);
    this.listarConteudoEletronico = true;
  }

  addOrEditConteudo(conteudo: ConteudoModel) {
    if (this.conteudo.id !== undefined) {
      this.editarItem(conteudo);
    } else {
      this.adicionarItem();
    }
  }

  editarItem(conteudo: ConteudoModel) {
    this.loading = true;
    this.conteudoService.editarItem(conteudo).subscribe(() => {
      this.loading = false;
      this.openSnackBarSuccess('Conteúdo editado com sucesso !');
      this.adicionarConteudo = false;
      this.listarConteudo = true;
      this.submit = false;
      this.conteudoForm.reset();
      this.conteudo = undefined;
      this.getConteudos(this.caixaId);
      this.getCaixa(this.caixaId);
    }, err => {
      this.loading = false;
      console.error(err);
      if (err.error.message === 'Conteúdo já criado com este RG de Item !') {
        this.openSnackBarError(err.error.message);
      } else {
        this.openSnackBarError('Preencha todos os campos obrigatórios !');
      }
    });
  }

  compararEditConteudo(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  // ALERTAS
  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  changeValue(event) {
    if (event.currentTarget.checked) {

      this.caixaService.changeRGAutomatico(this.caixaId, event.currentTarget.checked).subscribe(data => {
        const resultData = data;
        if (resultData.cod == 200) {
          this.conteudoForm.get('rgItem').setValue(resultData.result);
        } else {
          this.conteudoForm.get('rgItem').setValue('');
        }

      });

    } else {
      this.caixaService.changeRGAutomatico(this.caixaId, event.currentTarget.checked).subscribe(data => {
        const resultData = data;
        if (resultData.cod == 200) {
          this.conteudoForm.get('rgItem').setValue('');
        } else {
          this.conteudoForm.get('rgItem').setValue('');
        }
      });
    }
  }

  onDateInput(event) {
    const value = event.target.value;
    if (value.length > 10) {
      event.target.value = value.substring(1);
      this.conteudo.dataInicial = event.target.value;
    }
  }

  setType(event: any) {
    let index = event.target.selectedIndex - 1;
    let jsonSave = this.tipoConteudos[index];
    localStorage.setItem('RM_TYPE_CACHE', JSON.stringify(jsonSave));
  }

  setTypeOnInit() {
    const typeCache = localStorage.getItem('RM_TYPE_CACHE');
    if (typeCache !== null) {
      this.conteudoForm.get('nodeDicionario').setValue(JSON.parse(typeCache));
      this.conteudo.nodeDicionario = JSON.parse(typeCache);
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/adicionar-conteudo/adicionar-conteudo.component.ts